export default __webpack_public_path__ + "static/media/cpttm.eaea2cf1.png";